import { NavLink } from "react-router-dom";
import { useR2 } from 'providers/R2Provider';
import { usePrivacy } from "providers/PrivacyProvider";

const SubNavLink = ({ to, label, isPrivate }) => {
  const { toggleMainNav } = useR2();
  const { privateMode } = usePrivacy();

  if (isPrivate && !privateMode) return;

  return (
    <div className="mainnav__subnav-link">
      <NavLink to={to} onClick={toggleMainNav}>{label}</NavLink>
    </div>
  );
};

export default SubNavLink;